/**
 *
 * @module authenticationFlow
 * @see https://github.bamtech.co/sdk-doc/spec-sdk/blob/master/specs/feature_overviews/identity-bam.md#oneid-get-authentication-flow
 * @see https://github.bamtech.co/services-commons/public-api/blob/master/swagger/services/bam-idp.md#checkresponse
 *
 */

/**
 *
 * @since 3.9.0
 * @typedef AuthenticationFlow
 * @type {Object}
 * @desc Enumerates the known authentication operations from the Bam Identity Service.
 * @example AuthenticationFlow.authenticate // 'Login'
 *
 * @property {String} createIdentity - indicates a user has not been registered and must create a new Identity
 * @property {String} oneTimePasscode - indicates a user needs to request a one time passcode before authenticating
 * @property {String} authenticate - indicates a user can be authenticated and has been registered with BamIdp
 *
 * @note the service returns values that do not match the SDK keys in the spec
 *
 */
export default {
    /**
     *
     * @access public
     * @since 3.9.0
     * @type {String}
     *
     */
    authenticate: 'Login',
    /**
     *
     * @access public
     * @since 3.9.0
     * @type {String}
     *
     */
    createIdentity: 'Register',
    /**
     *
     * @access public
     * @since 3.9.0
     * @type {String}
     *
     */
    oneTimePasscode: 'OTP'
};



// WEBPACK FOOTER //
// ./src/services/identity/bam/authenticationFlow.js